<template>
  <div>
    <span class="custom-chip" v-if="searched.ticket_number"><strong>Nr karnetu:</strong>&nbsp;{{searched.ticket_number}}
          <span class="close-icon" @click="changeSearchData('ticket_number')"><v-icon
            size="18px">fas fa-times-circle</v-icon></span>
        </span>

    <span class="custom-chip" v-if="searched.ticket_person"><strong>Imię i nazwisko:</strong>&nbsp;{{searched.ticket_person}}
          <span class="close-icon" @click="changeSearchData('ticket_person')"><v-icon
            size="18px">fas fa-times-circle</v-icon></span>
        </span>

    <span class="custom-chip" v-if="searched.invoice_number"><strong>Nr FV:</strong>&nbsp;{{searched.invoice_number}}
          <span class="close-icon" @click="changeSearchData('invoice_number')"><v-icon
            size="18px">fas fa-times-circle</v-icon></span>
        </span>

    <span class="custom-chip" v-if="searched.status"><strong>Status:</strong>&nbsp;{{searched.status | convertStatusToName}}
          <span class="close-icon" @click="changeSearchData('status')"><v-icon size="18px">fas fa-times-circle</v-icon></span>
        </span>

    <span class="custom-chip" v-if="searched.locked"><strong>Zablokowane:</strong>&nbsp;{{searched.locked | convertLockedToName}}
          <span class="close-icon" @click="changeSearchData('locked')"><v-icon size="18px">fas fa-times-circle</v-icon></span>
        </span>

    <span class="custom-chip" v-if="searched.created"><strong>Wydano:</strong>&nbsp;{{searched.created}}
          <span class="close-icon" @click="changeSearchData('created')"><v-icon size="18px">fas fa-times-circle</v-icon></span>
        </span>

    <span class="custom-chip" v-if="searched.expiration_date"><strong>Wygasa:</strong>&nbsp;{{searched.expiration_date}}
          <span class="close-icon" @click="changeSearchData('expiration_date')"><v-icon
            size="18px">fas fa-times-circle</v-icon></span>
        </span>

    <span class="custom-chip" v-if="searched.user_id"><strong>Pracownik:</strong>&nbsp;{{searched.user_id.name}} {{searched.user_id.surname}}
          <span class="close-icon" @click="changeSearchData('user_id')"><v-icon
            size="18px">fas fa-times-circle</v-icon></span>
        </span>

    <span style="display: inline-block; margin-bottom: 10px">
          <button class="btn-search-toggle"
                  @click="toggle = !toggle; $emit('toggleSearch', toggle)">
            <v-icon size="15px">fas fa-search</v-icon>
          </button>
          <v-btn color="#555474" class="mt-0 mb-0 mr-0 ml-2" @click="$router.push({name: 'CreateTicket'})" dark>
            <v-icon size="15px" class="icon-btn">fas fa-plus</v-icon>&nbsp;Dodaj karnet
          </v-btn>
        </span>
  </div>
</template>

<script>
  export default {
    name: 'TicketChips',
    props: {
      searched: Object,
      searchTickets: Boolean,
    },
    data() {
      return {
        toggle: false,
      };
    },
    methods: {
      changeSearchData(element) {
        this.$emit('updateData', element);
      },
    },
    filters: {
      convertStatusToName(status) {
        switch (status) {
          case 'F':
            return 'Zakończone';
          case 'N':
            return 'Nowe';
          case 'I':
            return 'W realizacji';
          default:
            return 'Nieznany status';
        }
      },
      convertLockedToName(locked) {
        switch (locked) {
          case '0':
            return 'NIE';
          case '1':
            return 'TAK';
          default:
            return 'Nieznany';
        }
      },
    },
  };
</script>

<style scoped>

</style>
